import { Button, Box, HStack, Image, Text } from "@chakra-ui/react";

import { DiscontinuedBadge, getDiscontinued } from "mlp-sdk";

interface Props {
  label: string;
  icon: string;
  primaryCTAText: string;
  primaryCTAUrl: string;
  secondaryCTAText: string;
  secondaryCTAUrl: string;
  tvl: string | undefined;
  dataKey?: string;
}

const MobileCard = ({
  label,
  icon,
  primaryCTAText,
  primaryCTAUrl,
  secondaryCTAText,
  secondaryCTAUrl,
  tvl,
  dataKey,
}: Props) => {
  const discontinued = getDiscontinued(dataKey);
  // A discontinued network never falls back to the CMS primary CTA: for a fully
  // sunset network there is no primary CTA at all, so the button is not rendered.
  const primaryText = discontinued
    ? discontinued.primaryCTAText
    : primaryCTAText;
  const primaryUrl = discontinued ? discontinued.primaryCTAUrl : primaryCTAUrl;
  const secondaryText = discontinued?.learnMoreText ?? secondaryCTAText;
  const secondaryUrl = discontinued?.learnMoreUrl ?? secondaryCTAUrl;

  return (
    <Box
      w="full"
      h={168}
      borderRadius={16}
      p={0}
      bg="#E6F8EF"
      filter={discontinued ? "grayscale(1)" : undefined}
      opacity={discontinued ? 0.85 : 1}
    >
      <Box p={4} pos="relative" overflow="hidden" borderRadius={16}>
        <HStack align="center" gap={2} pr="90px">
          <Text fontSize={20} fontWeight={600}>
            {label}
          </Text>
          {discontinued && (
            <DiscontinuedBadge label={discontinued.badge} placement="inline" />
          )}
          <Image
            pos="absolute"
            top={-2}
            right={-3}
            boxSize="90px"
            src={icon}
            alt={label}
          />
        </HStack>
        <Text textAlign="left" mt={6} textStyle="p16" fontWeight={600}>
          {tvl ? (
            <>
              {tvl} <Text as="span">staked</Text>
            </>
          ) : (
            "Coming soon"
          )}
        </Text>
        <HStack mt={4} gap={2}>
          {secondaryText && (
            <Button as="a" href={secondaryUrl} flex={1} variant="outline">
              {secondaryText}
            </Button>
          )}
          {primaryText && (
            <Button as="a" href={primaryUrl} flex={1} bg="primary !important">
              {primaryText}
            </Button>
          )}
        </HStack>
      </Box>
    </Box>
  );
};

export default MobileCard;
